import { IPolicy, ITransaction } from './IPoliciesViewModels';
interface IPoliciesData {
  data: Array<IPoliciesResponseItem>;
  success: boolean;
  errors?: IerrorMessage;
}

interface IPolicyData {
  data: IPolicy;
  success: boolean;
  errors?: IerrorMessage;
}
// User Defined Type Guard - to ensure we can validate if the object from API meet all the criteria to be cast to this interface
function isPoliciesData(arg: any): arg is IPoliciesData {
  return arg && typeof arg.data !== 'undefined' && typeof arg.success !== 'undefined';
}

interface IPoliciesResponseItem {
  accountNo: string;
  accountProductType: string;
  balanceAmount: number;
  centrelinkFlag: boolean;
  closedDate: string;
  investmentOptionId: number;
  isActive: boolean;
  isRBACashLinked: boolean;
  maturityDetails?: IPoliciesResponseMaturityDetails;
  nextPaymentAmount: number;
  nextPaymentDate?: Date;
  productName: string;
  term: string;
  unitPrice: number;
  units: number;
}
// User Defined Type Guard - to ensure we can validate if the object from API meet all the criteria to be cast to this interface
function isPoliciesResponseItem(arg: any): arg is IPoliciesResponseItem {
  return (
    arg &&
    typeof arg.accountNo !== 'undefined' &&
    typeof arg.accountProductType !== 'undefined' &&
    typeof arg.balanceAmount !== 'undefined' &&
    typeof arg.investmentOptionId !== 'undefined' &&
    typeof arg.isActive !== 'undefined' &&
    typeof arg.isRBACashLinked !== 'undefined' &&
    typeof arg.centrelinkFlag !== 'undefined' &&
    typeof arg.nextPaymentAmount !== 'undefined' &&
    typeof arg.productName !== 'undefined' &&
    typeof arg.term !== 'undefined' &&
    typeof arg.unitPrice !== 'undefined' &&
    typeof arg.units !== 'undefined'
  );
}

interface IPoliciesResponseMaturityDetails {
  isInstructionReceived: boolean;
  maturityDate?: Date;
  maturityValue: number;
  maturityType: string;
}
// User Defined Type Guard - to ensure we can validate if the object from API meet all the criteria to be cast to this interface
function isPoliciesResponseMaturityDetails(arg: any): arg is IPoliciesResponseMaturityDetails {
  return (
    arg &&
    typeof arg.isInstructionReceived !== 'undefined' &&
    typeof arg.maturityValue !== 'undefined' &&
    typeof arg.maturityType !== 'undefined'
  );
}

interface IerrorMessage {
  code?: string;
  message?: string;
}

interface ITransactionsData {
  data: ITransaction[];
  success: boolean;
  errors?: IerrorMessage;
}

export {
  IPolicyData,
  IPoliciesData,
  IPoliciesResponseItem,
  IPoliciesResponseMaturityDetails,
  IerrorMessage,
  isPoliciesResponseMaturityDetails, // User Defined Type Guard
  isPoliciesResponseItem, // User Defined Type Guard
  isPoliciesData, // User Defined Type Guard
  ITransactionsData,
};
